import QuestionFillin from './view';

export default QuestionFillin;


// WEBPACK FOOTER //
// ./src/entry_question_editor/question/exercise/step/sub-question/fillin/index.js